<div class="card arquivo-card-view">
    <div class="card-header">
        <h6 class="card-title">
            {{title}}
        </h6>
        <p class="form-text text-muted" [innerHTML]="headerText" *ngIf="headerText"></p>
    </div>

    <div class="card-filter">
        <sgt-arquivo-card-filter
            [filter]="filter"
            [dropupMultiselects]="dropupMultiselectsFilters"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-arquivo-card-filter>                    
    </div>

    <div class="card-table">
        <sgt-arquivo-table
            #table
            [filter]="filter"
            [referencia]="referencia"
            [idReferencia]="idReferencia"
            [idTable]="idTable"
            [canDelete]="canEdit"
            (delete)="onDelete($event)">
        </sgt-arquivo-table>
    </div>    


    <div class="card-footer">
        <div class="btn-group dropup" *ngIf="table?.selected?.length > 0">
            <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                {{table.selected.length | decimalFormat: 1:0:0}} Selecionado(s)
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" (click)="table?.openSelected()">
                    <i class="fas fa-external-link-alt"></i> Abrir
                </a>
                <a class="dropdown-item" (click)="table?.printSelected()">
                    <i class="fas fa-print"></i> Imprimir
                </a>                
            </div>
        </div>  

        <button type="button" class="btn btn-primary" (click)="openUploadModal()" *ngIf="canEdit">
            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Arquivos
        </button>                 
    </div>
</div>

<sgt-arquivo-upload-modal
    #uploadModal
    [autoUpload]="true"
    (afterUpload)="onAfterUpload($event)">
</sgt-arquivo-upload-modal>